import React from 'react';
import { compose } from 'redux-starter-kit';
import { connect } from 'react-redux';
import Store from 'store/store';
import Tables from 'components/Table';
import { formatValue } from 'components/IPS/PastPerformanceTable/utils';
import { makeStyles } from '@material-ui/core';

const { Table, TableRow, TableHead, TableCell } = Tables;

const { selectors } = Store;

interface MaxDrawdowmProps {
  investments: any;
}

const useStyles = makeStyles({
  row: {
    '&:nth-child(even):not(.MuiTableRow-head)': {
      backgroundColor: '#f7f7f7'
    }
  }
});

const MaxDrawdowm = ({ investments }: MaxDrawdowmProps) => {
  const classes = useStyles();
  return (
    <>
      <div style={{ paddingTop: '2rem' }}>
        <Table>
          <TableHead cells={['', '1y', '3y', '5y']} />
          {investments.map((fund: any, index: number) => {
            return (
              <TableRow className={classes.row} key={index}>
                <TableCell style={{ fontWeight: 700 }}>{fund.name}</TableCell>
                <TableCell>
                  {formatValue(fund.maximum_one_y_drawdown)}
                </TableCell>
                <TableCell>
                  {formatValue(fund.maximum_three_y_drawdown)}
                </TableCell>
                <TableCell>
                  {formatValue(fund.maximum_five_y_drawdown)}
                </TableCell>
              </TableRow>
            );
          })}
        </Table>
      </div>
    </>
  );
};

export default compose(
  connect((state: any) => ({
    investments:
      selectors.investmentAnalyserSelectors.checkedResearchInvestments(state)
  }))
)(MaxDrawdowm);
